module.exports = __webpack_public_path__ + "static/media/A_wa_ux.35b9e079.png";